export const ahiCapabilities = [
  'Multimodal reasoning', 'Image generation', 'Image understanding', 'Video product demos', 'Video generation',
  'Video understanding', 'Audio transcription', 'Meeting notes', 'Meeting memory keeper', 'Action items',
  'Slide creation', 'Document drafting', 'Spreadsheet analysis', 'PDF analysis', 'Evidence search',
  'Citation grounding', 'Web research', 'Browser automation', 'Code generation', 'Sandbox execution',
  'Data analysis', 'Chart generation', 'Workflow building', 'Specialist teams', 'Human approvals',
  'Policy checks', 'Access controls', 'Audit trails', 'Decision records', 'Knowledge graphs',
  'Context graphs', 'CRM updates', 'Ticket resolution', 'Email triage', 'Calendar planning',
  'Procurement review', 'Contract analysis', 'Financial reconciliation', 'Forecasting', 'Fashion merchandising',
  'Campaign briefs', 'Sales account plans', 'Incident response', 'Supply chain replanning', 'Hiring operations',
  'Board packs', 'Executive briefings', 'Root cause analysis', 'Anomaly detection', 'Translation'
];

export const toolsToDitch = [
  'Salesforce', 'HubSpot', 'Jira', 'Asana', 'Monday.com', 'Trello', 'Zendesk', 'Intercom',
  'Slack Workflows', 'Notion', 'Confluence', 'Google Docs', 'Google Sheets', 'Google Slides',
  'Tableau', 'Power BI', 'Looker', 'Snowflake UI', 'Amplitude', 'Mixpanel', 'Marketo',
  'Mailchimp', 'Zapier', 'Make.com', 'Workato', 'MuleSoft', 'DocuSign', 'Calendly',
  'Gong', 'Chorus.ai', 'Seismic', 'Highspot', 'Outreach', 'SalesLoft', 'Otter', 'Fireflies'
];

export const connectorDestinations = [
  'PostgreSQL', 'MySQL', 'MongoDB', 'Redis', 'Amazon S3', 'Azure Blob', 'Google Cloud Storage',
  'Snowflake', 'Databricks', 'BigQuery', 'Redshift', 'Kafka', 'RabbitMQ', 'Elasticsearch',
  'Splunk', 'Datadog', 'GitHub', 'GitLab', 'Bitbucket', 'Stripe', 'Plaid', 'Shopify',
  'Google Drive', 'SharePoint', 'OneDrive', 'Dropbox', 'Box', 'Gmail', 'Google Calendar',
  'Slack', 'Microsoft Teams', 'Salesforce', 'HubSpot', 'ServiceNow', 'Zendesk', 'Intercom',
  'Okta', 'Active Directory', 'SAP', 'Oracle ERP', 'NetSuite', 'Workday', 'Figma', 'Miro',
  'Zoom', 'REST APIs', 'GraphQL', 'MCP tools'
];

export const suggestedProblems = [
  'Turn meeting notes into owned actions and a decision record',
  'Create a cited board deck from documents, data, and live research',
  'Investigate an operational incident and stop before consequential action',
  'Generate a multimodal product campaign across slides, image, and video'
];